import { ExtendedAddress } from '@porterin/booking-flow/src/order-review/domain/entities/ExtendedAddress';
import { Waypoint } from '@porterin/booking-flow/src/order-review/domain/entities/Waypoint';
import { LocationAccuracyCmpDesktop } from '@porterin/component-library/src/location-accuracy/components/LocationAccuracyCmpDesktop';
import { LocationProvider } from '@porterin/component-library/src/location-accuracy/contexts/LocationContext';
import React from 'react';

export interface LocationAccuracyProps {
  is_open: Waypoint | null;
  close_modal: () => void;
  waypoint: Waypoint;
  on_confirm: (address: ExtendedAddress) => void;
}

export const LocationAccuracyWrapperDesktop: React.FC<
  LocationAccuracyProps
> = ({ is_open, close_modal, waypoint, on_confirm }) => {
  return (
    <LocationProvider
      waypoint={waypoint}
      close_modal={close_modal}
      on_confirm={on_confirm}
    >
      <LocationAccuracyCmpDesktop
        data-testid="location-cmp"
        close_modal={close_modal}
      />
    </LocationProvider>
  );
};
